import { useMutation } from "@tanstack/react-query";
import submitSa from "../../controllers/appointments/submit-sa";

const usePostAppointmentSubmitSA = () => {
  return useMutation(submitSa, {});
};
export default usePostAppointmentSubmitSA;
